import { render, staticRenderFns } from "./test_info.vue?vue&type=template&id=2392ccdf&scoped=true&"
import script from "./test_info.vue?vue&type=script&lang=js&"
export * from "./test_info.vue?vue&type=script&lang=js&"
import style0 from "./test_info.vue?vue&type=style&index=0&id=2392ccdf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2392ccdf",
  null
  
)

export default component.exports